import getPanAndZoom from './getPanAndZoom';

/**
 * Returns the CSS transform that needs to be applied to the
 * document surface in order to pan and zoom the document.
 */
export default function getDocumentSurfaceStyle() {
    // NOTE: order is important: translate THEN scale.
    const { x, y, zoom } = getPanAndZoom();
    return {
        transform: `translate(${x}px, ${y}px) scale(${zoom})`,
        transformOrigin: '0 0 0',
    };
}
